import React, { useEffect, useState } from 'react';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { WatchlistManagerModal } from '~/modules/watchlist-manager-modal/WatchlistManagerModal';
import { queryKeys } from '~/routes/query-params';
import { SearchAssetWidget } from '~/widgets/search-asset-widget/SearchAssetWidget';

import { WidgetPathNames, widgetPaths } from './widget-utils';

export const Widgets = () => {
  const { params } = useQueryParams();
  const [activeWidget, setActiveWidget] = useState<WidgetPathNames | null>();
  useEffect(() => {
    validateWidgetParams();
  }, [params]);

  const validateWidgetParams = () => {
    const widgetParam = params[queryKeys.widget] as WidgetPathNames | null;
    setActiveWidget(widgetParam);
  };

  const widgetViews = {
    [widgetPaths.searchAsset]: {
      component: <SearchAssetWidget />,
    },
    [widgetPaths.watchlistManagerModal]: {
      component: <WatchlistManagerModal />,
    },
  };

  if (!activeWidget || !widgetViews[activeWidget]?.component) {
    return null;
  }

  return <div>{widgetViews[activeWidget].component}</div>;
};
